import { render, staticRenderFns } from "./GlobalLinkResolver.vue?vue&type=template&id=94885e06&"
import script from "./GlobalLinkResolver.vue?vue&type=script&lang=js&"
export * from "./GlobalLinkResolver.vue?vue&type=script&lang=js&"
import style0 from "./GlobalLinkResolver.vue?vue&type=style&index=0&id=94885e06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports